export const ActivePointBoxberry = () => (
	<svg width="115" height="124" viewBox="0 0 115 124" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_ddd_25188_21651)">
			<path
				d="M85.793 62.375C85.793 83.2188 61.793 95 61.793 95C61.793 95 37.793 82.7656 37.793 62.375C37.793 48.3608 48.5381 37 61.793 37C75.0478 37 85.793 48.3608 85.793 62.375Z"
				fill="white"
			/>
		</g>
		<g clipPath="url(#clip0_25188_21651)">
			<path
				d="M59.6471 56.3138C59.6471 57.8241 58.3775 59.0128 56.7617 59.0128C55.2036 58.9988 53.9485 57.8101 53.9341 56.3278C53.9341 54.8315 55.2325 53.6009 56.8194 53.6149C58.3775 53.6288 59.6471 54.8455 59.6471 56.3138Z"
				fill="#ED1752"
			/>
			<path
				d="M56.8047 62.8442C58.4061 62.8442 59.6756 64.0609 59.6468 65.5712C59.6324 67.0395 58.3339 68.2421 56.7903 68.2282C55.2034 68.2282 53.9194 66.9975 53.9482 65.4873C53.9482 64.0189 55.2178 62.8442 56.8047 62.8442Z"
				fill="#ED1752"
			/>
			<path
				d="M58.8389 60.9146C58.8389 59.3903 60.1084 58.2156 61.7242 58.2296C63.2679 58.2436 64.5518 59.4742 64.5518 60.9286C64.5518 62.3969 63.2679 63.5995 61.7098 63.6135C60.094 63.6275 58.8389 62.4389 58.8389 60.9146Z"
				fill="#ED1752"
			/>
			<path
				d="M58.8389 70.0386C58.8389 68.5143 60.1084 67.3397 61.7242 67.3536C63.2679 67.3676 64.5518 68.5982 64.5518 70.0526C64.5518 71.5209 63.2679 72.7236 61.7098 72.7376C60.094 72.7515 58.8389 71.5629 58.8389 70.0386Z"
				fill="#ED1752"
			/>
			<path
				d="M58.8389 51.6851C58.8389 50.1608 60.1084 48.9861 61.7242 49.0001C63.2679 49.0141 64.5518 50.2447 64.5518 51.6991C64.5518 53.1674 63.2679 54.3701 61.7098 54.384C60.094 54.398 58.8389 53.2094 58.8389 51.6851Z"
				fill="#A6CE39"
			/>
			<path
				d="M66.5719 58.9987C64.9562 58.9987 63.701 57.81 63.7155 56.2857C63.7299 54.8034 64.985 53.6147 66.5575 53.6147C68.13 53.6147 69.4573 54.8733 69.4284 56.3417C69.3996 57.81 68.13 58.9987 66.5719 58.9987Z"
				fill="#ED1752"
			/>
			<path
				d="M66.5571 68.2285C64.9702 68.2145 63.7006 66.9979 63.7295 65.4736C63.7583 63.9913 64.999 62.8306 66.586 62.8306C68.1441 62.8306 69.4136 64.0192 69.428 65.5015C69.4425 66.9839 68.1152 68.2424 66.5571 68.2285Z"
				fill="#ED1752"
			/>
			<path
				d="M71.3902 63.6134C69.8321 63.5854 68.6058 62.3827 68.6202 60.8864C68.6347 59.3761 69.9042 58.2015 71.52 58.2155C73.0781 58.2294 74.3044 59.4321 74.2899 60.9424C74.2611 62.4666 72.9915 63.6413 71.3902 63.6134Z"
				fill="#ED1752"
			/>
			<path
				d="M51.7701 63.6134C50.212 63.5854 48.9857 62.3827 49.0001 60.8864C49.0146 59.3761 50.2841 58.2015 51.8999 58.2155C53.458 58.2294 54.6842 59.4321 54.6698 60.9424C54.641 62.4666 53.3714 63.6413 51.7701 63.6134Z"
				fill="#ED1752"
			/>
		</g>
		<defs>
			<filter
				id="filter0_ddd_25188_21651"
				x="0.792969"
				y="0"
				width="114"
				height="124"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="8" />
				<feGaussianBlur stdDeviation="5" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25188_21651" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.05 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_25188_21651" result="effect2_dropShadow_25188_21651" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="-4" dy="-4" />
				<feGaussianBlur stdDeviation="16.5" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
				<feBlend mode="normal" in2="effect2_dropShadow_25188_21651" result="effect3_dropShadow_25188_21651" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_25188_21651" result="shape" />
			</filter>
			<clipPath id="clip0_25188_21651">
				<rect width="25.29" height="23.885" fill="white" transform="translate(49 49)" />
			</clipPath>
		</defs>
	</svg>
)
